export default {
  listOfCustom: [
    'requestor_id',
    'utm',
    'days_in_advance',
    'dropoff_date',
    'dropoff_city',
    'dropoff_city_id',
    'dropoff_continent',
    'dropoff_country',
    'dropoff_location_id',
    'dropoff_state',
    'dropoff_time',
    'dropoff_type',
    'dropoff_location',
    'dropoff_continent_id',
    'pickup_date',
    'pickup_city',
    'pickup_city_id',
    'pickup_continent',
    'pickup_country',
    'pickup_location_id',
    'pickup_location',
    'pickup_time',
    'pickup_type',
    'pickup_state',
    'rental_length',
    'authentication',
    'commission',
    'product',
    'payment',
    'plan',
    'supplier_name',
    'rentalcover',
    'payment_currency',
    'payment_value',
    'promotions',
    'coverage',
    'optionals',
    'additional_included',
    'type',
    'payment_currency_symbol',
    'payment_formatted_amount',
    'advantages',
    'formatted_amount',
    'payment_amount',
    'order_code',
    'type',
    'category',
    'voucher_discount_formatted',
    'pickup_formatted_date',
    'dropoff_formatted_date',
    'rental_company_evaluation',
    'currency_after_amount',
    'vehicle_value',
    'rental_company_fees',
    'cashback_value',
    'optionals_value',
    'rental_cover_active',
    'rental_cover_value_type',
    'rental_cover_value_total',
    'rental_cover_value_daily',
    'payment_type',
    'booking_code',
    'booking_status_str',
    'payment_status_str',
    'payment_type_str',
    'status_update_date',
    'language',
    'promotion_name'
  ]
}
